<div class="overlay" *ngIf="isLoading">
  <div class="fa fa-refresh spinner"></div>
</div>

